<label [class.clickable]="clickable">
  <ng-content></ng-content>
  @if (hasRequiredBadge) {
    <span class="badge-required">*</span>
  }
  <ng-content select="rt-icon-help"></ng-content>
  <ng-content select="rt-badge"></ng-content>
</label>
@if (description) {
  <span class="description">
    {{ description }}
  </span>
}
